export default __webpack_public_path__ + "static/media/T860_CoC.6f45a0cd.pdf";